<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['Cantidad'],
                    datasets: [
                        {
                            label: 'Locales y Bodegas visitadas por Servicios de Control de Plagas',
                            backgroundColor: hexToRgba('#00ff41', 70),
                            fill: true,
                            data: [787]
                        },
                        {
                            label: 'Desinfectaciones',
                            backgroundColor: hexToRgba('#ffec3c', 70),
                            fill: true,
                            data: [9]
                        },
                        {
                            label: 'Fiscalizaciones Control Mosca de la Fruta',
                            backgroundColor: hexToRgba('#ff0326', 70),
                            fill: true,
                            data: [4]
                        },
                        {
                            label: 'Controles Sanitarios e Higiénicos en Estaciones Sanitarias',
                            backgroundColor: hexToRgba('#09c0ff', 70),
                            fill: true,
                            data: [13]
                        },
                        {
                            label: 'Puntos de Agua',
                            backgroundColor: hexToRgba('#b251ff', 70),
                            fill: true,
                            data: [5]
                        },
                        {
                            label: 'Baños Públicos',
                            backgroundColor: hexToRgba('#ff5d84', 70),
                            fill: true,
                            data: [9]
                        }

                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                            ticks: {
                                precision: 0,
                                beginAtZero: true,
                                suggestedMax: 50
                            }
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
